import PictureContainer from './containers/PictureContainer';
export { BaseWrapper } from './components/Picture';

export default PictureContainer;
